/**
 * Vuex shim for schedule module — keeps the 'schedule' namespace registered
 * in Vuex for any legacy consumers outside the migrated module.
 *
 * TODO: audit remaining consumers and delete this shim when none are left.
 */
import { useScheduleStore } from './useScheduleStore'

export default {
  namespaced: true,

  state: () => ({
    schedules: [],
    selectedSchedules: [],
    loadingAppointments: false,
    pendingAppointmentsRequest: null,
    events: [],
    surgicalEvents: [],
    appointmentRefreshTrigger: 0
  }),

  getters: {
    selectedSchedules: state => state.selectedSchedules,
    appointmentRefreshTrigger: state => state.appointmentRefreshTrigger
  },

  mutations: {
    setSchedules(state, payload) {
      state.schedules = payload
    },
    setSelectedSchedules(state, payload) {
      state.selectedSchedules = payload
    },
    setEvents(state, payload) {
      state.events = payload
    },
    setSurgicalEvents(state, payload) {
      state.surgicalEvents = payload
    },
    setLoading(state, payload) {
      state.loadingAppointments = payload
    },
    setPendingAppointmentsRequest(state, payload) {
      state.pendingAppointmentsRequest = payload
    },
    triggerAppointmentRefresh(state) {
      state.appointmentRefreshTrigger++
    }
  },

  actions: {
    async getAppointments(_, { clinicId, props }) {
      // Delegate to Pinia store
      // Note: Pinia store is not initialized in Vuex context, use it directly
      // This shim exists only for legacy components in schedule2
      // eslint-disable-next-line no-undef
      const store = useScheduleStore()
      return store.getAppointments(clinicId, props)
    },

    async getScheduleOptions({ commit }, clinicId) {
      const store = useScheduleStore()
      await store.getScheduleOptions(clinicId)
      // Sync state back to Vuex for legacy mapState consumers
      commit('setSchedules', store.schedules)
      commit('setSelectedSchedules', store.selectedSchedules)
    },

    setSelectedSchedules({ commit }, payload) {
      const store = useScheduleStore()
      store.setSelectedSchedules(payload)
      commit('setSelectedSchedules', payload)
    },

    async getSurgicalMapAppoinments({ commit }, params) {
      const store = useScheduleStore()
      await store.getSurgicalMapAppointments(params)
      commit('setSurgicalEvents', store.surgicalEvents)
    },

    refreshAppointments() {
      const store = useScheduleStore()
      store.refreshAppointments()
    }
  }
}
